// extracted by mini-css-extract-plugin
export var mb0 = "utilities-module--mb0--822da";
export var mb20 = "utilities-module--mb20--e6e0c";
export var mb40 = "utilities-module--mb40--65dc3";
export var mt20 = "utilities-module--mt20--8ad82";
export var mt40 = "utilities-module--mt40--81771";
export var textCenter = "utilities-module--textCenter--0c5de";